import { put, select, takeLatest } from 'redux-saga/effects'
import {
  buscarVehiculos,
  buscarVehiculosError,
  buscarVehiculosExito,
  selectSelectedVehicle,
  setSelectedVehicle,
} from './vehiculoSlice'
import { VehiculoDevRepository } from '../adapters/VehiculoDevRepository'
import { Matricula } from '../../Domain/Matricula'
import { BuscarVehiculoPorMatricula } from '../../Application/BuscarVehiculoPorMatricula'
import { vehiclesMatch } from '../../Domain/vehicleIdentity'
import { IAppState } from '../../../../../../common/context/context'
import { getAreaPrivadaVehicle } from '../../../../../../common/context/selectors/areaPrivadaSelector'

function* buscarVehiculosSaga(action: ReturnType<typeof buscarVehiculos>) {
  try {
    const matricula = new Matricula(action.payload)

    const areaPrivadaVehicle = yield select((state: IAppState) =>
      getAreaPrivadaVehicle(state, matricula.value())
    )

    if (areaPrivadaVehicle?.vehicle) {
      const currentVehicle = yield select((state: IAppState) =>
        selectSelectedVehicle(state)
      )
      if (
        !currentVehicle ||
        !vehiclesMatch(currentVehicle, areaPrivadaVehicle.vehicle)
      ) {
        yield put(setSelectedVehicle(areaPrivadaVehicle.vehicle))
      }
    }

    const useCase = new BuscarVehiculoPorMatricula(VehiculoDevRepository)

    const vehiculos = yield useCase.execute(matricula)

    if (vehiculos) {
      yield put(buscarVehiculosExito(vehiculos))
      if (vehiculos.length === 1) {
        const currentVehicle = yield select((state: IAppState) =>
          selectSelectedVehicle(state)
        )
        if (!currentVehicle || !vehiclesMatch(currentVehicle, vehiculos[0])) {
          yield put(setSelectedVehicle(vehiculos[0]))
        }
      }
    } else {
      yield put(buscarVehiculosError('No hemos encontrado el vehículo.'))
    }
  } catch (err: unknown) {
    const message =
      err instanceof Error ? err.message : 'Error inesperado al buscar por matrícula.'
    yield put(buscarVehiculosError(message))
  }
}

export function* vehiculoSaga() {
  yield takeLatest(buscarVehiculos.type, buscarVehiculosSaga)
}
